export default "__VITE_ASSET__BTGdYJV3__"